<template>

    <div class="container pt-4" id="galery_container">
      <h2 class="h2 text-center g_header  text-uppercase my-3 text-black">{{$t('g_diff_work')}}</h2>
      <div class="row">
        <div class="col-10 offset-1 px-3 g_part" id="expert_g_part">
          <vue-picture-swipe :items="exert_items" style="text-align: center;"></vue-picture-swipe>
        </div>
      </div>
      <h2 class="h2 text-center g_header text-uppercase mt-5">{{$t('g_vorota_work')}}</h2>
      <div class="row" style="margin-bottom: 130px;">
        <div class="col-10 offset-1 px-3 g_part" id="vorota_g_part">
          <vue-picture-swipe :items="vorota_items" style="text-align: center;"></vue-picture-swipe>
        </div>
      </div>
      <h2 class="h2 text-center g_header text-uppercase mt-5">{{$t('g_shodi_work')}}</h2>
      <div class="row" style="margin-bottom: 130px;">
        <div class="col-10 offset-1 px-3 g_part" id="vorota_g_part">
          <vue-picture-swipe :items="shodi_items" style="text-align: center;"></vue-picture-swipe>
        </div>
      </div>
    </div>
    
</template>



<script>

  import VuePictureSwipe from 'vue-picture-swipe';
  export default {
    data() {
      return {
        shodi_items: [
          {
            src: 'imgs/shodi/g1w.jpg',
            thumbnail: 'imgs/shodi/thumb/g1_tn.jpg',
            w: 960,
            h: 1280,
            alt: '' // optional alt attribute for thumbnail image
          },
          {
            src: 'imgs/shodi/g2w.jpg',
            thumbnail: 'imgs/shodi/thumb/g2_tn.jpg',
            w: 960,
            h: 1280,
            alt: '' // optional alt attribute for thumbnail image
          },
          {
            src: 'imgs/shodi/g3w.jpg',
            thumbnail: 'imgs/shodi/thumb/g3_tn.jpg',
            w: 960,
            h: 1280,
            alt: '' // optional alt attribute for thumbnail image
          },
          {
            src: 'imgs/shodi/g4w.jpg',
            thumbnail: 'imgs/shodi/thumb/g4_tn.jpg',
            w: 960,
            h: 1280,
            alt: '' // optional alt attribute for thumbnail image
          },
          {
            src: 'imgs/shodi/g5w.jpg',
            thumbnail: 'imgs/shodi/thumb/g5_tn.jpg',
            w: 960,
            h: 1280,
            alt: '' // optional alt attribute for thumbnail image
          },
          {
            src: 'imgs/shodi/g6w.jpg',
            thumbnail: 'imgs/shodi/thumb/g6_tn.jpg',
            w: 960,
            h: 1280,
            alt: '' // optional alt attribute for thumbnail image
          },
          {
            src: 'imgs/shodi/g7w.jpg',
            thumbnail: 'imgs/shodi/thumb/g7_tn.jpg',
            w: 960,
            h: 1280,
            alt: '' // optional alt attribute for thumbnail image
          },
          {
            src: 'imgs/shodi/g8w.jpg',
            thumbnail: 'imgs/shodi/thumb/g8_tn.jpg',
            w: 960,
            h: 1280,
            alt: '' // optional alt attribute for thumbnail image
          },
          {
            src: 'imgs/shodi/g9w.jpg',
            thumbnail: 'imgs/shodi/thumb/g9_tn.jpg',
            w: 960,
            h: 1280,
            alt: '' // optional alt attribute for thumbnail image
          },
          {
            src: 'imgs/shodi/g10w.jpg',
            thumbnail: 'imgs/shodi/thumb/g10_tn.jpg',
            w: 960,
            h: 1280,
            alt: '' // optional alt attribute for thumbnail image
          },
          {
            src: 'imgs/shodi/g11w.jpg',
            thumbnail: 'imgs/shodi/thumb/g11_tn.jpg',
            w: 960,
            h: 1280,
            alt: '' // optional alt attribute for thumbnail image
          },
          {
            src: 'imgs/shodi/g12w.jpg',
            thumbnail: 'imgs/shodi/thumb/g12_tn.jpg',
            w: 960,
            h: 1280,
            alt: '' // optional alt attribute for thumbnail image
          },
          {
            src: 'imgs/shodi/g13w.jpg',
            thumbnail: 'imgs/shodi/thumb/g13_tn.jpg',
            w: 960,
            h: 1280,
            alt: '' // optional alt attribute for thumbnail image
          },
          {
            src: 'imgs/shodi/g14w.jpg',
            thumbnail: 'imgs/shodi/thumb/g14_tn.jpg',
            w: 960,
            h: 1280,
            alt: '' // optional alt attribute for thumbnail image
          },
                    {
            src: 'imgs/shodi/g15w.jpg',
            thumbnail: 'imgs/shodi/thumb/g15_tn.jpg',
            w: 960,
            h: 1280,
            alt: '' // optional alt attribute for thumbnail image
          },
          {
            src: 'imgs/shodi/g16w.jpg',
            thumbnail: 'imgs/shodi/thumb/g16_tn.jpg',
            w: 960,
            h: 1280,
            alt: '' // optional alt attribute for thumbnail image
          },
          {
            src: 'imgs/shodi/g17w.jpg',
            thumbnail: 'imgs/shodi/thumb/g17_tn.jpg',
            w: 960,
            h: 1280,
            alt: '' // optional alt attribute for thumbnail image
          },
          {
            src: 'imgs/shodi/g18w.jpg',
            thumbnail: 'imgs/shodi/thumb/g18_tn.jpg',
            w: 960,
            h: 1280,
            alt: '' // optional alt attribute for thumbnail image
          },
          {
            src: 'imgs/shodi/g19w.jpg',
            thumbnail: 'imgs/shodi/thumb/g19_tn.jpg',
            w: 960,
            h: 1280,
            alt: '' // optional alt attribute for thumbnail image
          },
          {
            src: 'imgs/shodi/g20w.jpg',
            thumbnail: 'imgs/shodi/thumb/g20_tn.jpg',
            w: 960,
            h: 1280,
            alt: '' // optional alt attribute for thumbnail image
          },
        ],
        vorota_items: [
          {
            src: 'imgs/vorota/g3w.jpg',
            thumbnail: 'imgs/vorota/thumb/g3_tn.jpg',
            w: 960,
            h: 1280,
            alt: '' // optional alt attribute for thumbnail image
          },
          {
            src: 'imgs/vorota/g4w.jpg',
            thumbnail: 'imgs/vorota/thumb/g4_tn.jpg',
            w: 960,
            h: 1280,
            alt: '' // optional alt attribute for thumbnail image
          },
          {
            src: 'imgs/vorota/g5w.jpg',
            thumbnail: 'imgs/vorota/thumb/g5_tn.jpg',
            w: 960,
            h: 1280,
            alt: '' // optional alt attribute for thumbnail image
          },
          {
            src: 'imgs/vorota/g6w.jpg',
            thumbnail: 'imgs/vorota/thumb/g6_tn.jpg',
            w: 960,
            h: 1280,
            alt: '' // optional alt attribute for thumbnail image
          },
          {
            src: 'imgs/vorota/g7w.jpg',
            thumbnail: 'imgs/vorota/thumb/g7_tn.jpg',
            w: 960,
            h: 1280,
            alt: '' // optional alt attribute for thumbnail image
          },
          {
            src: 'imgs/vorota/g8w.jpg',
            thumbnail: 'imgs/vorota/thumb/g8_tn.jpg',
            w: 960,
            h: 1280,
            alt: '' // optional alt attribute for thumbnail image
          },
          {
            src: 'imgs/vorota/g9w.jpg',
            thumbnail: 'imgs/vorota/thumb/g9_tn.jpg',
            w: 960,
            h: 1280,
            alt: '' // optional alt attribute for thumbnail image
          },
          {
            src: 'imgs/vorota/g10w.jpg',
            thumbnail: 'imgs/vorota/thumb/g10_tn.jpg',
            w: 960,
            h: 1280,
            alt: '' // optional alt attribute for thumbnail image
          },
          {
            src: 'imgs/vorota/g11w.jpg',
            thumbnail: 'imgs/vorota/thumb/g11_tn.jpg',
            w: 960,
            h: 1280,
            alt: '' // optional alt attribute for thumbnail image
          },
          {
            src: 'imgs/vorota/g12w.jpg',
            thumbnail: 'imgs/vorota/thumb/g12_tn.jpg',
            w: 960,
            h: 1280,
            alt: '' // optional alt attribute for thumbnail image
          },
          {
            src: 'imgs/vorota/g13w.jpg',
            thumbnail: 'imgs/vorota/thumb/g13_tn.jpg',
            w: 960,
            h: 1280,
            alt: '' // optional alt attribute for thumbnail image
          },
          {
            src: 'imgs/vorota/g14w.jpg',
            thumbnail: 'imgs/vorota/thumb/g14_tn.jpg',
            w: 960,
            h: 1280,
            alt: '' // optional alt attribute for thumbnail image
          },
          {
            src: 'imgs/vorota/g15w.jpg',
            thumbnail: 'imgs/vorota/thumb/g15_tn.jpg',
            w: 960,
            h: 1280,
            alt: '' // optional alt attribute for thumbnail image
          },
        ],
        exert_items: [
          {
            src: 'imgs/maingallery/expert/g16w.jpg',
            thumbnail: 'imgs/maingallery/expert/thumb/g16_tn.jpg',
            w: 960,
            h: 1280,
            alt: '' // optional alt attribute for thumbnail image
          },
          {
            src: 'imgs/maingallery/expert/g17w.jpg',
            thumbnail: 'imgs/maingallery/expert/thumb/g17_tn.jpg',
            w: 960,
            h: 1280,
            alt: '' // optional alt attribute for thumbnail image
          },
          {
            src: 'imgs/maingallery/expert/g14w.jpg',
            thumbnail: 'imgs/maingallery/expert/thumb/g14_tn.jpg',
            w: 960,
            h: 1280,
            alt: '' // optional alt attribute for thumbnail image
          },
          {
            src: 'imgs/maingallery/expert/g15w.jpg',
            thumbnail: 'imgs/maingallery/expert/thumb/g15_tn.jpg',
            w: 960,
            h: 1280,
            alt: '' // optional alt attribute for thumbnail image
          },
          {
            src: 'imgs/maingallery/expert/g1w.jpg',
            thumbnail: 'imgs/maingallery/expert/thumb/g1_tn.jpg',
            w: 960,
            h: 1280,
            alt: '' // optional alt attribute for thumbnail image
          },
          // {
          //   src: 'imgs/maingallery/expert/g2.jpg',
          //   thumbnail: 'imgs/maingallery/expert/thumb/g2_tn.jpg',
          //   w: 960,
          //   h: 1280,
          //   alt: '' // optional alt attribute for thumbnail image
          // },
          {
            src: 'imgs/maingallery/expert/g3w.jpg',
            thumbnail: 'imgs/maingallery/expert/thumb/g3_tn.jpg',
            w: 960,
            h: 1280,
            alt: '' // optional alt attribute for thumbnail image
          },
          {
            src: 'imgs/maingallery/expert/g4w.jpg',
            thumbnail: 'imgs/maingallery/expert/thumb/g4_tn.jpg',
            w: 960,
            h: 1280,
            alt: '' // optional alt attribute for thumbnail image
          },
                  {
            src: 'imgs/maingallery/expert/g5w.jpg',
            thumbnail: 'imgs/maingallery/expert/thumb/g5_tn.jpg',
            w: 960,
            h: 1280,
            alt: '' // optional alt attribute for thumbnail image
          },
          {
            src: 'imgs/maingallery/expert/g6w.jpg',
            thumbnail: 'imgs/maingallery/expert/thumb/g6_tn.jpg',
            w: 960,
            h: 1280,
            alt: '' // optional alt attribute for thumbnail image
          },
          //         {
          //   src: 'imgs/maingallery/expert/g7.jpg',
          //   thumbnail: 'imgs/maingallery/expert/thumb/g7_tn.jpg',
          //   w: 960,
          //   h: 1280,
          //   alt: '' // optional alt attribute for thumbnail image
          // },
          {
            src: 'imgs/maingallery/expert/g8w.jpg',
            thumbnail: 'imgs/maingallery/expert/thumb/g8_tn.jpg',
            w: 960,
            h: 1280,
            alt: '' // optional alt attribute for thumbnail image
          },
                  {
            src: 'imgs/maingallery/expert/g9w.jpg',
            thumbnail: 'imgs/maingallery/expert/thumb/g9_tn.jpg',
            w: 960,
            h: 1280,
            alt: '' // optional alt attribute for thumbnail image
          },
          {
            src: 'imgs/maingallery/expert/g10w.jpg',
            thumbnail: 'imgs/maingallery/expert/thumb/g10_tn.jpg',
            w: 960,
            h: 1280,
            alt: '' // optional alt attribute for thumbnail image
          },
          {
            src: 'imgs/maingallery/expert/g11w.jpg',
            thumbnail: 'imgs/maingallery/expert/thumb/g11_tn.jpg',
            w: 960,
            h: 1280,
            alt: '' // optional alt attribute for thumbnail image
          },
          {
            src: 'imgs/maingallery/expert/g12w.jpg',
            thumbnail: 'imgs/maingallery/expert/thumb/g12_tn.jpg',
            w: 960,
            h: 1280,
            alt: '' // optional alt attribute for thumbnail image
          },
          {
            src: 'imgs/maingallery/expert/g13w.jpg',
            thumbnail: 'imgs/maingallery/expert/thumb/g13_tn.jpg',
            w: 960,
            h: 1280,
            alt: '' // optional alt attribute for thumbnail image
          },
      ]};
    }
  }
  
</script>

<style >

  @import url('https://fonts.googleapis.com/css?family=Roboto+Slab');

  .g_part figure {
    /* width: 100px;  */
    display: inline-block;
    margin: 15px; 
  }
  #galery_container {
    overflow-y: visible !important;
  }

  .g_header {
    font-family: 'Roboto Slab', serif;
    font-weight: 700;
  }
</style>
